var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32959 17.5C12.1956 17.5 15.3296 14.366 15.3296 10.5C15.3296 6.63401 12.1956 3.5 8.32959 3.5C4.4636 3.5 1.32959 6.63401 1.32959 10.5C1.32959 14.366 4.4636 17.5 8.32959 17.5Z",
    stroke: "#290E41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32959 7.5V10.5L9.82959 12",
    stroke: "#290E41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8396 15.85L12.4896 19.68C12.4445 20.1786 12.2141 20.6423 11.8438 20.9792C11.4735 21.3162 10.9902 21.502 10.4896 21.5H6.15957C5.6589 21.502 5.17568 21.3162 4.80537 20.9792C4.43507 20.6423 4.20463 20.1786 4.15957 19.68L3.80957 15.85M3.81957 5.15L4.16957 1.32C4.21448 0.823078 4.4435 0.360886 4.81169 0.0241538C5.17987 -0.312578 5.66062 -0.499529 6.15957 -0.499999H10.5096C11.0102 -0.50203 11.4935 -0.316201 11.8638 0.0207742C12.2341 0.357749 12.4645 0.821357 12.5096 1.32L12.8596 5.15",
    stroke: "#290E41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.603f04fc4f7162bbcae7a3bec3e5fe26.svg";
export { ForwardRef as ReactComponent };